import { Component, OnInit } from '@angular/core';

import { Cintillo } from '../../../entities/cintillo/imagenes';
import { ImagenesService } from './services/imagenes.service';

@Component({
  selector: 'app-images',
  templateUrl: './images.component.html',
  styleUrls: ['./images.component.scss']
})
export class ImagesComponent implements OnInit {
  public informacion: Cintillo | null = null;

  constructor(private imagesService: ImagenesService) {}

  ngOnInit(): void {
    this.getPromociones();
  }

  getPromociones(): void {
    this.imagesService.getPromociones().subscribe((result) => {
      this.informacion = result;
    });
  }
}
